import { Descendant } from 'slate';

export const getNode = (value: string): Descendant[] => ([{
  type: 'paragraph',
  children: [
    { text: value },
  ],
}]);
